<awair-floor-plan-list-item *ngFor="let floor of floors"
                            [width]="'262px'"
                            [height]="'48px'"
                            [mainText]="floor.name"
                            [isRightClickable]="canDelete"
                            [backgroundColor]="selectedFloorId === floor.id ? '#F0F9FD': '#FFFFFF'"
                            [subText]="(floor.floorPlan?.devices) ? floor.floorPlan.devices.length + ' Devices' : '0 Devices'"
                            (itemSelect)="onSelectFloor(floor.id)">
  <awair-caret-right-icon *ngIf="selectedFloorId && selectedFloorId === floor.id"
                          left
                          [color]="'#64C2E6'">
  </awair-caret-right-icon>

  <!-- More -->
  <awair-dropdown-wrapper *ngIf="canDelete"
                          right>
    <awair-more-button dropdown-btn></awair-more-button>
    <awair-dropdown-ul dropdown [horizontalAlignment]="HorizontalAlignment.Right">
      <li class="__delete-list-item"
          (click)="onDeleteFloor(floor)">
        Delete
      </li>
    </awair-dropdown-ul>
  </awair-dropdown-wrapper>
  <!-- /.More -->
</awair-floor-plan-list-item>
